import React from 'react';
import { PluginFunction, BaseTreeItem } from '@kastjs/runtime-core';
import { aopFactory } from './aop';
import merge from 'lodash/merge';

export interface IframePluginOptions {
  query: Record<string, any>;
}

export type IframeExtension = {
  iframeUrl?: string | (() => string);
};

type AppTreeItem = BaseTreeItem<IframeExtension>;

const resloveRoute = (routes: AppTreeItem[], cb: (route: AppTreeItem) => AppTreeItem) =>
  routes.map(route => {
    const result = cb?.(route);
    if (result.children && result.children.length > 0) {
      result.children = resloveRoute(result.children, cb);
    }
    return result || route;
  });

function getRealUrl(url: IframeExtension['iframeUrl'], query: IframePluginOptions['query']) {
  if (typeof url === 'function') return url();
  if (typeof url !== 'string') {
    console.warn('iframeUrl must string or function ');
    return null;
  }
  const realUrl = new URL(url);
  const params = new URLSearchParams(realUrl.search);
  if (query && typeof query === 'object') {
    for (let i in query) {
      if (!params.has(i) && query[i]) {
        params.append(i, query[i]);
      }
    }
  }
  realUrl.search = params.toString();
  return realUrl.toString();
}

const iframeAccessPlugin: PluginFunction<IframePluginOptions> = async (context, options) => {
  context.appSettings.routes = resloveRoute(context.appSettings.routes, route =>
    route?.iframeUrl && !route.component
      ? {
          ...route,
          component: () => (
            <iframe
              src={getRealUrl(route?.iframeUrl, options.query)}
              title={route.name + ''}
              style={{
                width: '100%',
                height: 'calc(100vh - 118px)',
                border: 0,
              }}
            />
          ),
        }
      : route
  );
};

export const iframeAccessPluginAOP = aopFactory(iframeAccessPlugin, {
  before(_, params, options) {
    const { userData, systemId, currentSubSystemName } = options;
    return merge(
      {
        query: {
          userId: userData?.ksUserId,
          userName: userData?.email,
          sysId: systemId,
          subSystemName: currentSubSystemName,
        },
      },
      params
    );
  },
});

export default iframeAccessPlugin;
